import { Sparkles, TrendingUp, Lightbulb } from 'lucide-react';

export default function AIInsightCard({ analysis, suggestions, trend }) {
  const trendIcons = {
    positive: { icon: '🌟', color: 'text-green-600', label: 'Pozitif Trend' },
    needs_attention: { icon: '💭', color: 'text-amber-600', label: 'Dikkat Gerekli' },
    neutral: { icon: '📊', color: 'text-blue-600', label: 'Normal' }
  };

  const currentTrend = trendIcons[trend] || trendIcons.neutral;

  return (
    <div className="bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50 rounded-2xl p-6 shadow-lg hover-lift animate-fade-in">
      <div className="flex items-center gap-2 mb-4">
        <Sparkles className="w-5 h-5 text-purple-600" />
        <h3 className="text-lg font-semibold text-gray-900">AI Analiz</h3>
      </div>
      
      {/* Analysis */}
      <div className="bg-white bg-opacity-70 rounded-xl p-4 mb-4">
        <p className="text-gray-800 leading-relaxed">{analysis}</p>
      </div>

      {/* Trend */}
      <div className="flex items-center gap-2 mb-4 p-3 bg-white bg-opacity-50 rounded-lg">
        <TrendingUp className="w-4 h-4" />
        <span className="text-2xl">{currentTrend.icon}</span>
        <span className={`font-medium ${currentTrend.color}`}>{currentTrend.label}</span>
      </div>

      {/* Suggestions */}
      {suggestions && suggestions.length > 0 && (
        <div>
          <div className="flex items-center gap-2 mb-3">
            <Lightbulb className="w-4 h-4 text-amber-500" />
            <h4 className="font-semibold text-gray-800">Öneriler</h4>
          </div>
          <ul className="space-y-2">
            {suggestions.map((suggestion, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-purple-600 mt-0.5">•</span>
                <span>{suggestion}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}